export const COUNTER_LEGEND = "Characters left:";
